import React from "react";
import PropTypes from "prop-types";

import { Type } from "@ebscois/react-component-library";
import { StyledHeaderDelimiter, StyledLink } from "./_.styled";

const TopicUpdatesLink = ({ updatedAtLabel, createdAtLabel, onClick }) => (
  <>
    {(updatedAtLabel || createdAtLabel) && (
      <StyledHeaderDelimiter color="gray800" />
    )}
    {updatedAtLabel && (
      <StyledLink kind="anchor" onClick={onClick}>
        {updatedAtLabel}
      </StyledLink>
    )}
    {createdAtLabel && !updatedAtLabel && (
      <Type element="p" fontSize="sm">
        {createdAtLabel}
      </Type>
    )}
  </>
);

TopicUpdatesLink.propTypes = {
  updatedAtLabel: PropTypes.string,
  createdAtLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default TopicUpdatesLink;
